import { randAvatarColorFullname } from 'js/utils/avatar';
import { capitalize } from 'filters/text';

const getFirstName = (user) => user.first_name ?? user.firstName ?? user.firstname ?? '';
const getLastName = (user) => user.last_name ?? user.lastName ?? user.lastname ?? '';
const getFullName = (user) => user.name ?? user.full_name ?? user.fullName ?? null;

const formatUserToCompassAvatar = (user) => {
    const initials = `${getFirstName(user)?.charAt(0)}${getLastName(user)?.charAt(0)}`;
    const colorType = randAvatarColorFullname(getFullNameUser(user));
    return {
        initials: initials.toUpperCase(),
        colorType,
        photo: user.avatar ?? '',
    };
};

const getFullNameUser = (user, capitalized = false) => {
    if (getFullName(user)) {
        return capitalize(getFullName(user)) ?? getFullName(user);
    }

    const firstName = capitalized ? capitalize(getFirstName(user)) : getFirstName(user);
    const lastName = capitalized ? capitalize(getLastName(user)) : getLastName(user);
    return firstName.concat(' ', lastName).trim();
};

export { formatUserToCompassAvatar, getFullNameUser };
